import * as React from 'react';

const MaterialLoading: React.FunctionComponent<{}> = () => (
    <svg className='loading-circle' version='1.1' width='512' height='512' viewBox='0 0 512 512'>
        <path d='M75.157 74.805c-46.432 46.344-75.157 110.415-75.157 181.195v0c0 141.385 114.615 256 256 256v0c141.385 0 256-114.615 256-256v0c0-70.78-28.725-134.851-75.154-181.191l-0.004-0.004-33.942 33.941c37.746 37.658 61.099 89.73 61.099 147.255v0c0 114.875-93.125 208-208 208v0c-114.875 0-208-93.125-208-208v0c0.001-57.525 23.353-109.596 61.095-147.25l0.004-0.004-33.942-33.942z'/>
    </svg>
);

export default MaterialLoading;
